// Unpublished Work © 2026 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {connect} from 'react-redux';
import {matchPath, withRouter} from 'react-router-dom';
import {MultiSelect} from '@deere/isg.component-library';
import {isAuthorized} from 'Common/utils/authorization-handler';
import {courseOperationsReportLinks} from 'Ui/constants/secondary-navbar-constants';
import {useDeepMemo} from 'Utils/react-utils';

function CourseOperationsReportSelect(props) {
    const {
        history,
        location: {pathname},
        translations,
        ...userAuth
    } = props;

    const authorizedLinks = useDeepMemo(
        () => courseOperationsReportLinks.filter((link) => isAuthorized(link, userAuth)),
        [userAuth]
    );

    const items = useDeepMemo(() => authorizedLinks.map(({
        basePath, name
    }) => ({
        id: basePath,
        title: translations[name]
    })), [authorizedLinks, translations]);

    const selectedLink = authorizedLinks.find(({basePath}) => matchPath(pathname, {
        path: basePath
    }));

    return (
        <MultiSelect
            items={items}
            labels={{
                placeholder: translations.REPORT
            }}
            onChange={([id]) => {
                const {path} = authorizedLinks.find(({basePath}) => basePath === id);

                history.push(path);
            }}
            selectedIds={selectedLink ? [selectedLink.basePath] : []}
            single={true}
            width={220}
        />
    );
}

CourseOperationsReportSelect.propTypes = {
    appKeys: PropTypes.appKeys,
    hasMyJDSession: PropTypes.bool,
    history: PropTypes.history,
    isgToggles: PropTypes.object,
    isMigrated: PropTypes.bool,
    location: PropTypes.location,
    myJdPermissions: PropTypes.myJdPermissions,
    permissions: PropTypes.legacyPermissions,
    superUser: PropTypes.bool,
    translations: PropTypes.translations
};

export function mapStateToProps(state) {
    return {
        appKeys: state.account.appKeys,
        hasMyJDSession: state.account.hasMyJDSession,
        isgToggles: state.account.isgToggles,
        isMigrated: state.membership.isMigrated,
        myJdPermissions: state.account.myJdPermissions,
        permissions: state.account.permissions,
        superUser: state.account.superUser
    };
}

export default connect(mapStateToProps)(withRouter(CourseOperationsReportSelect));
